// @ts-nocheck
/**
 * Bundle Quantity Selector
 * Handles switching between bundle product tiers.
 *
 * On the first (page-load) product, the Seal Subscriptions native widget has
 * already auto-initialized against the page's `<div class="sealsubs-target-element">`.
 *
 * For subsequent bundle products, that widget is opaque to the theme and does
 * not re-initialize on its own. To keep the form submission correct, we:
 *   1. Hide the native widget's input/select controls (so the form does not
 *      submit the wrong selling plan for the previously-rendered product).
 *   2. Render a single "One Time Purchase" row (bundle tiers 2 & 3 are one-time
 *      only — the Liquid marks only the first tier subscriptionAvailable) into a
 *      wrapper placed right before the Add to Cart button.
 *   3. Mirror clicks into the hidden native widget so the visual state stays
 *      consistent if the user toggles back to the first bundle option.
 */
(function () {
  'use strict';

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  // Read the native tier-1 one-time card's "Want to save X%? Switch to
  // Subscription" sub-label so the custom (tier 2/3) row can show the same
  // TEXT (non-clickable). Falls back to constructing it from the subscribe
  // card's discount % if the native message isn't found.
  function getSwitchToSubLabel(target) {
    if (!target) return '';
    var otCard = target.querySelector(
      '.sls-option-container:not([data-selling-plan-group])'
    );
    if (otCard) {
      var nodes = otCard.querySelectorAll('*');
      for (var i = 0; i < nodes.length; i++) {
        var t = (nodes[i].textContent || '').replace(/\s+/g, ' ').trim();
        if (
          t &&
          /switch to subscri/i.test(t) &&
          t.length < 80 &&
          !/[$£€]/.test(t) &&
          !/one\s*time/i.test(t)
        ) {
          return t;
        }
      }
    }
    var subCard = target.querySelector(
      '.sls-option-container[data-selling-plan-group]'
    );
    if (subCard) {
      var m = (subCard.textContent || '').match(/(\d{1,2})\s*%/);
      if (m) return 'Want to save ' + m[1] + '%? Switch to Subscription';
    }
    return '';
  }

  function initBundleSelector() {
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('bundle_preview') === 'true') {
      document.querySelectorAll('.bundle-quantity-selector--preview').forEach(function (el) {
        el.classList.remove('bundle-quantity-selector--preview');
      });
    }

    var selectors = document.querySelectorAll('.bundle-quantity-selector:not(.bundle-quantity-selector--preview)');

    selectors.forEach(function (selectorEl) {
      var blockId = selectorEl.dataset.blockId;
      if (!blockId) return;

      var buyButtonsBlock = selectorEl.closest('.buy-buttons-block');
      if (!buyButtonsBlock) return;

      var productFormComponent = buyButtonsBlock.querySelector('product-form-component');
      var form = productFormComponent ? productFormComponent.querySelector('form') : null;
      var variantInput = form ? form.querySelector('input[name="id"]') : null;
      var sealsubsTarget = form ? form.querySelector('.sealsubs-target-element') : null;

      var originalHandle = null;
      var checkedRadio = selectorEl.querySelector('input[name^="bundle-quantity"]:checked');
      if (checkedRadio) originalHandle = checkedRadio.value;

      var customWrapper = null;

      // Look up a bundle product's embedded subscription data by handle.
      // The selector snippet renders a <script type="application/json"> with
      // id="bundle-sub-data-{handle}-{blockId}" that includes spPickerPrice,
      // compareAtPrice, and discountPercentage.
      function getBundleSubData(handle) {
        var node = document.getElementById('bundle-sub-data-' + handle + '-' + blockId);
        if (!node) return null;
        try {
          return JSON.parse(node.textContent);
        } catch (e) {
          return null;
        }
      }

      /* Tier products mirror the base product's options, so a tier switch has to carry the
         shopper's flavour across. Without this the form falls back to the tier product's FIRST
         variant, and a shopper sitting on Black Cherry who taps 2 Tubs is silently sold Salted
         Caramel. Single-variant products are unaffected: the match and the fallback are the
         same variant. Data comes from #sb-bundle-pricing-data, which already carries every
         tier's variants. */
      var bundleTiers = (function () {
        var node = document.getElementById('sb-bundle-pricing-data');
        if (!node) return null;
        try {
          return JSON.parse(node.textContent).tiers || null;
        } catch (e) {
          return null;
        }
      })();

      var currentOptionTitle = null;

      function tierByHandle(handle) {
        if (!bundleTiers) return null;
        for (var i = 0; i < bundleTiers.length; i++) {
          if (bundleTiers[i].handle === handle) return bundleTiers[i];
        }
        return null;
      }

      function baseTier() {
        return tierByHandle(originalHandle) || (bundleTiers && bundleTiers[0]) || null;
      }

      function rememberOptionFromVariant(id) {
        var base = baseTier();
        if (!base || !base.variants) return false;
        for (var i = 0; i < base.variants.length; i++) {
          if (String(base.variants[i].id) === String(id)) {
            currentOptionTitle = base.variants[i].title;
            return true;
          }
        }
        return false;
      }

      /* Read the chosen options straight from the variant picker.

         The variant:update event is NOT reliable here: measured on the live PDP, the picker
         writes the form's hidden input without this selector ever seeing an event, so a tier
         switch kept using whatever flavour the page first loaded with and sold Salted Caramel
         to a Black Cherry shopper.

         Scoped by product id, not by container. The product column also holds other pickers
         (recommendations, quick add), and a plain `.variant-option input:checked` there
         returned five values from three different products. Every picker input's name ends
         with `-<productId>`, which is exact. */
      function readOptionTitleFromPicker() {
        var baseRadio = selectorEl.querySelector('input[name^="bundle-quantity"]');
        var productId = baseRadio && baseRadio.dataset.productId;
        if (!productId) return null;
        var suffix = '-' + productId;
        var scope = selectorEl.closest('.product-details-column') || document;
        var checked = scope.querySelectorAll('input[type="radio"]:checked');
        var values = [];
        for (var i = 0; i < checked.length; i++) {
          var el = checked[i];
          if (el.name && el.name.slice(-suffix.length) === suffix && el.value) values.push(el.value);
        }
        return values.length ? values.join(' / ') : null;
      }

      // Matched on variant title, which is the option values joined, so one option or several
      // both work. Falls back to the first available variant when a tier does not stock the
      // shopper's flavour, which is better than blocking the sale.
      function variantForTier(handle) {
        var tier = tierByHandle(handle);
        if (!tier || !tier.variants || !tier.variants.length) return null;
        var firstAvailable = null;
        for (var i = 0; i < tier.variants.length; i++) {
          var v = tier.variants[i];
          if (!firstAvailable && v.available) firstAvailable = v;
          if (currentOptionTitle && v.title === currentOptionTitle && v.available) return v;
        }
        return firstAvailable || tier.variants[0];
      }

      // On first load (and when toggling back to the first option), force
      // the Seal widget to its Subscribe & Save option and sync the Add to
      // Cart button to that selection. With a bundle quantity selector on
      // the page, the bundle widget should drive the default selection;
      // we want Subscribe to be the auto-selected choice so the ATC button
      // shows the subscription price + discount.
      function forceSubscribeOnLoad() {
        if (!sealsubsTarget) return;
        var subBox = sealsubsTarget.querySelector(
          '.sls-option-container[data-selling-plan-group]'
        );
        if (!subBox) return;

        // Deactivate every option first
        sealsubsTarget.querySelectorAll('.sls-option-container').forEach(function (b) {
          b.classList.remove('sls-active');
          var inp = b.querySelector('input.sls-option');
          if (inp) inp.checked = false;
          var ariaRadio = b.querySelector('[role="radio"]');
          if (ariaRadio) ariaRadio.setAttribute('aria-checked', 'false');
        });

        // Activate the Subscribe option
        subBox.classList.add('sls-active');
        var subRadio = subBox.querySelector('input.sls-option');
        if (subRadio) {
          subRadio.checked = true;
          var ariaRadioSub = subBox.querySelector('[role="radio"]');
          if (ariaRadioSub) ariaRadioSub.setAttribute('aria-checked', 'true');
          subRadio.dispatchEvent(new Event('change', { bubbles: true }));
          subRadio.dispatchEvent(new Event('input', { bubbles: true }));
          subRadio.click();
        }
      }

      function selectBundle(handle) {
        var radio = selectorEl.querySelector('input[value="' + handle + '"]');
        if (!radio) return;

        // The radio's data-variant-id is the tier's first available variant, which is only
        // right for a single-variant product. Prefer the variant matching the chosen flavour,
        // re-read from the picker here rather than trusted from an event.
        var fromPicker = readOptionTitleFromPicker();
        if (fromPicker) currentOptionTitle = fromPicker;
        var matched = variantForTier(handle);
        var variantId = matched ? matched.id : radio.dataset.variantId;
        var price = matched ? matched.price : radio.dataset.price;
        var available = matched ? !!matched.available : radio.dataset.available === 'true';
        var productId = radio.dataset.productId;
        var productUrl = radio.dataset.productUrl;

        selectorEl.querySelectorAll('.bundle-option').forEach(function (el) {
          el.classList.toggle('bundle-option--selected', el.dataset.handle === handle);
        });

        if (variantInput) {
          variantInput.value = variantId;
        }

        if (productFormComponent) {
          productFormComponent.dataset.productId = productId;
          productFormComponent.dataset.productUrl = productUrl;
        }

        var addToCartBtn = buyButtonsBlock.querySelector('[ref="addToCartButton"]');
        if (addToCartBtn) addToCartBtn.disabled = !available;

        if (handle === originalHandle) {
          showNativeWidget();
          hideCustomWrapper();
          // Force the native widget back to Subscribe & Save (auto-default)
          // so the ATC button always reflects the subscription price when
          // the user toggles back to the first bundle option.
          forceSubscribeOnLoad();
        } else {
          hideNativeWidget();
          renderCustomWrapper(handle, price);
        }

        updatePriceDisplay(price);
        updateAtcButton(handle, price, handle === originalHandle);
      }

      function updateAtcButton(handle, priceInCents, useNativeWidget) {
        if (useNativeWidget) {
          var nativePrice = readNativeWidgetPrice();
          if (nativePrice) {
            writeAtcPrice(
              reformatMoney(nativePrice.final),
              reformatMoney(nativePrice.strike),
              nativePrice.isSubscribe
            );
          }
          return;
        }

        // 2nd/3rd bundle: read the rendered custom widget's price + strike
        // directly. The Liquid-rendered HTML is the source of truth — the
        // embedded JSON's selling-plan allocation order is unreliable.
        if (customWrapper) {
          var priceEl = customWrapper.querySelector('.bundle-custom-subs__price');
          var strikeEl = customWrapper.querySelector('.bundle-custom-subs__strike');
          var finalText = priceEl ? priceEl.textContent.trim() : '';
          var strikeText = strikeEl ? strikeEl.textContent.trim() : '';
          if (finalText) {
            writeAtcPrice(finalText, strikeText, !!strikeText);
            return;
          }
        }

        // Fallback: derive from bundle option card
        var bundleOption = document.querySelector('.bundle-option[data-handle="' + handle + '"]');
        if (bundleOption) {
          var pm = bundleOption.querySelector('.bundle-option__price');
          if (pm) {
            var sm = bundleOption.querySelector('.bundle-option__savings');
            var num = (pm.textContent.match(/\$([\d,]+\.?\d*)/) || [])[1];
            if (num) {
              var subPrice = '$' + num;
              var strike = '';
              if (sm) {
                var sav = (sm.textContent.match(/\$([\d,]+\.?\d*)/) || [])[1];
                var qtyMatch = (bundleOption.querySelector('.bundle-option__label').textContent.match(/(\d+)/) || [])[1];
                if (sav && qtyMatch) {
                  var qty = parseInt(qtyMatch, 10);
                  strike = formatMoney(Math.round((parseFloat(num.replace(/,/g, '')) + parseFloat(sav.replace(/,/g, '')) / qty) * 100));
                }
              }
              writeAtcPrice(subPrice, strike, !!strike);
              return;
            }
          }
        }

        // Last resort fallback to JSON (may be inaccurate for some products)
        var subData = handle ? getBundleSubData(handle) : null;
        var variants = (subData && subData.variants) || [];
        var variantMatch = variants.filter(function (v) { return String(v.id) === String(variantInput ? variantInput.value : ''); })[0];

        var subPrice = variantMatch ? (variantMatch.spPickerPrice || variantMatch.price) : null;
        var compareAt = null;
        if (variantMatch && variantMatch.sellingPlans && variantMatch.sellingPlans.length) {
          compareAt = variantMatch.sellingPlans[0].compareAtPrice;
        }
        if (!compareAt) compareAt = variantMatch ? variantMatch.price : null;

        var finalText = subPrice || (priceInCents ? formatMoney(parseInt(priceInCents, 10)) : '');
        var strikeText = (compareAt && subPrice && compareAt !== subPrice) ? compareAt : '';
        writeAtcPrice(finalText, strikeText, !!strikeText);
      }

      function readNativeWidgetPrice() {
        if (!sealsubsTarget) return null;
        var box =
          sealsubsTarget.querySelector('.sls-option-container.sls-active') ||
          sealsubsTarget.querySelector('.sls-option-container');
        if (!box) return null;

        var isSubscribe =
          box.hasAttribute('data-selling-plan-group') ||
          box.innerText.toLowerCase().indexOf('subscribe') !== -1;

        var finalNode = null;
        var strikeNode = null;

        if (isSubscribe) {
          strikeNode = box.querySelector('.sls-original-price .money');
          finalNode =
            box.querySelector('.sls-price-container .sls-price > .money') ||
            box.querySelector('.sls-price .money') ||
            box.querySelector('.money');
        } else {
          finalNode =
            box.querySelector('.sls-one-time-price .money') ||
            box.querySelector('.sls-price-container .money') ||
            Array.from(box.querySelectorAll('.money')).find(function (el) {
              return !el.closest('.sls-original-price');
            });
        }

        var finalText = finalNode ? finalNode.innerText.trim() : '';
        var strikeText = strikeNode ? strikeNode.innerText.trim() : '';
        if (!finalText) return null;
        return { final: finalText, strike: strikeText, isSubscribe: isSubscribe };
      }

      function writeAtcPrice(finalText, strikeText, isSubscribe) {
        var buttonContents = document.querySelectorAll(
          '.add-to-cart-text__content'
        );
        if (!buttonContents.length) return;

        buttonContents.forEach(function (content) {
          var priceWrap = content.querySelector('.custom-atc-price-wrap');
          if (!priceWrap) {
            priceWrap = document.createElement('span');
            priceWrap.className = 'custom-atc-price-wrap';
            priceWrap.style.cssText = 'display:inline-flex;align-items:center;gap:4px;margin-left:6px;';
            priceWrap.innerHTML =
              '<span class="custom-atc-strike-price" style="text-decoration:line-through;margin-right:4px;display:none;"></span>' +
              '<span class="atc-price"></span>';
            content.appendChild(document.createTextNode(' '));
            content.appendChild(priceWrap);
          }
          var strikeEl = priceWrap.querySelector('.custom-atc-strike-price');
          var priceEl = priceWrap.querySelector('.atc-price');
          if (priceEl) priceEl.textContent = finalText;
          if (strikeEl) {
            if (isSubscribe && strikeText) {
              strikeEl.textContent = strikeText;
              strikeEl.style.display = '';
            } else {
              strikeEl.textContent = '';
              strikeEl.style.display = 'none';
            }
          }
        });
      }

      function showNativeWidget() {
        if (!sealsubsTarget) return;
        sealsubsTarget.style.display = '';
        sealsubsTarget.querySelectorAll('input, select').forEach(function (el) {
          el.disabled = false;
        });
      }

      function hideNativeWidget() {
        if (!sealsubsTarget) return;
        sealsubsTarget.style.display = 'none';
        sealsubsTarget.querySelectorAll('input, select').forEach(function (el) {
          el.disabled = true;
        });
      }

      function hideCustomWrapper() {
        if (customWrapper) {
          customWrapper.style.display = 'none';
        }
      }

      function renderCustomWrapper(handle, priceInCents) {
        if (!customWrapper) {
          customWrapper = document.createElement('div');
          customWrapper.className = 'bundle-custom-subs-wrapper';
          var formButtons = form.querySelector('.product-form-buttons');
          if (formButtons) {
            form.insertBefore(customWrapper, formButtons);
          } else {
            form.appendChild(customWrapper);
          }
        }

        customWrapper.innerHTML = buildCustomWidgetHTML(handle, priceInCents);
        customWrapper.style.display = '';
      }

      function buildCustomWidgetHTML(handle, priceInCents) {
        // Bundle tiers 2 & 3 are one-time only — the Liquid selector marks only
        // the first tier `subscriptionAvailable`. Render a single, selected
        // "One Time Purchase" row showing the tier's TOTAL price (the bundle
        // product's own price, passed in as priceInCents). updateAtcButton()
        // mirrors .bundle-custom-subs__price into the Add to Cart button, so
        // this element is also the source of truth for the ATC price.
        var total = priceInCents ? formatMoney(parseInt(priceInCents, 10)) : '';

        // Fallback: derive the total from the selected bundle option card.
        if (!total) {
          var bundleOption = document.querySelector('.bundle-option[data-handle="' + handle + '"]');
          if (bundleOption) {
            var priceEl = bundleOption.querySelector('.bundle-option__price');
            if (priceEl) {
              var pm = priceEl.textContent.match(/\$([\d,]+\.?\d*)/);
              if (pm) total = '$' + pm[1];
            }
          }
        }

        var h = '';
        h += '<div class="bundle-custom-subs">';
        h += '<div class="bundle-custom-subs__option bundle-custom-subs__option--active" data-type="onetime">';
        h += '<div class="bundle-custom-subs__label">';
        h += '<span class="bundle-custom-subs__radio"></span>';
        h += '<span class="bundle-custom-subs__title">One Time Purchase</span>';
        h += '<span class="bundle-custom-subs__price-wrap">';
        h += '<span class="bundle-custom-subs__price">' + total + '</span>';
        h += '</span>';
        h += '</div>'; // close .bundle-custom-subs__label
        var subLabel = getSwitchToSubLabel(sealsubsTarget);
        if (subLabel) {
          h += '<div class="bundle-custom-subs__note">' + escapeHtml(subLabel) + '</div>';
        }
        h += '</div>'; // close .bundle-custom-subs__option
        h += '<input type="hidden" name="selling_plan" value="" />';
        h += '</div>';
        return h;
      }

      function updatePriceDisplay(priceInCents) {
        var section = document.getElementById('product-information');
        if (!section) section = document;

        var priceComponent = section.querySelector('product-price');
        if (!priceComponent) return;

        var priceContainer = priceComponent.querySelector('[ref="priceContainer"]');
        if (!priceContainer) return;

        var formatted = formatMoney(parseInt(priceInCents, 10));
        priceContainer.innerHTML = '<span class="price">' + formatted + '</span>';
      }

      // Hardcoding two decimals here is what rendered "One Time Purchase $28.16" under a
      // page whose every other price reads $28. snippets/sb-money.liquid carries the shop
      // money format; the literal stays only as a fallback if this ever runs without it.
      function formatMoney(cents) {
        if (window.SBMoney) return window.SBMoney.format(cents);
        return '$' + (cents / 100).toFixed(2);
      }

      // Seal renders its own money strings and ignores the shop money format.
      function reformatMoney(text) {
        if (window.SBMoney) return window.SBMoney.reformat(text);
        return text;
      }

      selectorEl.addEventListener('change', function (e) {
        if (e.target.classList && e.target.classList.contains('bundle-option__radio')) {
          selectBundle(e.target.value);
        }
      });

      // When the user toggles between Subscribe & Save and One Time inside
      // the Seal widget, refresh the Add to Cart button price.
      if (sealsubsTarget) {
        sealsubsTarget.addEventListener('click', function () {
          setTimeout(function () {
            updateAtcButton(originalHandle, null, true);
          }, 80);
        });
        sealsubsTarget.addEventListener('change', function () {
          setTimeout(function () {
            updateAtcButton(originalHandle, null, true);
          }, 80);
        });
      }

      /* A flavour change writes the BASE product's variant into the form, which silently
         drops a shopper on 2 or 3 Units back to a single unit. Re-apply the active tier
         whenever the form lands back on a base variant. */
      function onVariantChange() {
        if (!bundleTiers || !variantInput) return;
        var fromPicker = readOptionTitleFromPicker();
        if (fromPicker) currentOptionTitle = fromPicker;
        if (!rememberOptionFromVariant(variantInput.value)) return;
        var checked = selectorEl.querySelector('input[name^="bundle-quantity"]:checked');
        if (checked && checked.value !== originalHandle) selectBundle(checked.value);
      }

      document.addEventListener('variant:update', function () { setTimeout(onVariantChange, 0); });
      document.addEventListener('variant:selected', function () { setTimeout(onVariantChange, 0); });

      if (variantInput) rememberOptionFromVariant(variantInput.value);

      // After Seal has had a chance to render its widget, force Subscribe
      // as the default selection and sync the Add to Cart button with the
      // subscription price + discount.
      var initTries = 0;
      var initInterval = setInterval(function () {
        initTries++;
        if (sealsubsTarget && sealsubsTarget.querySelector('.sls-option-container')) {
          forceSubscribeOnLoad();
          var checkedRadio = selectorEl.querySelector('input[name^="bundle-quantity"]:checked');
          if (checkedRadio) {
            updateAtcButton(checkedRadio.value, checkedRadio.dataset.price, true);
          }
          clearInterval(initInterval);
        } else if (initTries > 40) {
          clearInterval(initInterval);
        }
      }, 250);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundleSelector);
  } else {
    initBundleSelector();
  }
})();
